/**
 * Job 중지/재시도 mutation 훅.
 *
 * 성공 시 ``["jobs"]`` 프리픽스 캐시(목록 + ``["jobs", id]`` 상세)를 함께
 * 무효화해 상태 배지·버튼이 즉시 갱신되도록 한다. 우아한 중지는 서버에서
 * ``cancelling → cancelled`` 로 이어지므로, 폴링(useJobs/useJobDetail)이
 * 마감 상태까지 따라간다.
 *
 * ``useMutation`` generic 자리에 ``void`` 를 직접 쓰지 않고 ``mutationFn``
 * 반환 타입 추론에 맡긴다(ESLint ``no-invalid-void-type``).
 */

import { useMutation, useQueryClient } from "@tanstack/react-query";

import { cancelJob, retryJob } from "@/lib/api/jobs";

import { JOBS_QUERY_KEY } from "./useJobs";

export function useCancelJob() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (jobId: string) => cancelJob(jobId),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: JOBS_QUERY_KEY });
    },
  });
}

export function useRetryJob() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (jobId: string) => retryJob(jobId),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: JOBS_QUERY_KEY });
    },
  });
}
